import { useAuthContext } from "./useAuthContext"
import { useNavigate } from "react-router-dom"
import Cookies from "js-cookie"

const API = process.env.REACT_APP_API_URL || "http://localhost:4000"

export const useLogout = () => {
    const { dispatch } = useAuthContext()
    const navigate = useNavigate()

    const logout = async () => {
        // 1. Ask the server to revoke the refresh token + clear its cookies (best-effort —
        //    a failed request must never trap the user in a logged-in state).
        try {
            await fetch(`${API}/api/user/logout`, { method: "GET", credentials: "include" })
        } catch (_) { /* proceed with client-side logout regardless */ }

        // 2. Clear the cookies client-side too. js-cookie needs the exact path/domain the
        //    cookie was set with, so cover both the localhost cookie (no domain) and the prod
        //    parent-domain cookie. Without this, a page refresh re-reads a stale token and
        //    logs the user back in.
        for (const name of ["token", "refresh_token"]) {
            Cookies.remove(name, { path: "/" })
            Cookies.remove(name, { path: "/", domain: ".contentflashai.com" })
        }

        // 3. Drop per-session UI state so the next login starts clean.
        try {
            localStorage.removeItem("activeWorkspaceId")
            localStorage.removeItem("user")
        } catch (_) { /* localStorage may be unavailable */ }

        // 4. Update auth state + route to login.
        dispatch({ type: "LOGOUT" })
        navigate("/login", { replace: true })
    }

    return { logout }
}
